<template>
  <div class="main">
    <headerBar current="mtsapi"></headerBar>
    <div class="banner">
      <div>
        <h3>北京联运管家供应链管理有限公司</h3>
        <h4>北京联运管家供应链管理有限公司成立于2019年，是国家铁路集团下属企业与普洛斯隐山现代物流产业基金共同组建的一家混合所有制企业</h4>
        <router-link tag="p" to="/knowus">了解我们</router-link>
      </div>
    </div>
    <div class="process">
      <h3>调用流程</h3>
      <div>
        <img src="../assets/pc/api.png" alt="" />
      </div>
      <ul>
        <li>
          <img src="../assets/pc/icon-route.png" alt="" />
          <h4>铁路运踪服务综合API</h4>
          <p>铁运发到站、品名、是否到站、到达时间，以及装卸车各作业流程时间、剩余里程、预计到达时间等</p>
        </li>
        <li>
          <img src="../assets/pc/icon-goods.png" alt="" />
          <h4>铁路发运服务综合API</h4>
          <p>铁运需求单号、运单号码、发到站、发收货人、车种、车号、运输里程，以及品名、货重起票日期、起票时间等</p>
        </li>
        <li>
          <img src="../assets/pc/icon-transport.png" alt="" />
          <h4>铁路在途服务综合API</h4>
          <p>铁运运单各阶段与对应时间（如需求提报、受理、制票、装车、发运、到达、卸车、交付等），以及途径各站的到达、发车时间、经纬度等轨迹）</p>
        </li>
      </ul>
    </div>
    <contact></contact>
    <footerBar></footerBar>
  </div>
</template>

<script>
import headerBar from "../components/headerBar"
import contact from "../components/contact"
import footerBar from "../components/footerBar"
export default {
  components: { headerBar, contact, footerBar },
  data() {
    return {
      current: 3,
    }
  },
};
</script>

<style scoped>
.banner {
  background: url("../assets/pc/banner1.png") no-repeat center;
  background-size: 100%;
}

.banner div {
  height: 4.8rem;
  width: 13rem;
  margin: 0 auto;
  padding-top: 1rem;
}

.banner div h3 {
  font-size: 0.48rem;
  color: #fff;
  font-weight: bold;
}

.banner div h4 {
  color: #fff;
  width: 4.4rem;
  font-size: 0.16rem;
  line-height: 0.28rem;
  padding: 0.4rem 0 0.8rem;
}

.banner div p {
  width: 1.9rem;
  font-size: 0.16rem;
  line-height: 0.54rem;
  text-align: center;
  color: #fff;
  background: #1070ff;
  cursor: pointer;
}

.process h3 {
  text-align: center;
  font-size: 0.3rem;
  color: #091c2e;
  font-weight: bold;
  line-height: 1.6rem;
}

.process div img {
  display: block;
  margin: 0 auto;
  width: 12.8rem;
}

.process ul {
  margin-top: 0.6rem;
  display: flex;
  justify-content: center;
  background: #f5f7f9;
  padding: 0.7rem 0;
}

.process ul li {
  margin: 0 0.1rem;
  width: 4.12rem;
  height: 3.24rem;
  padding: 0.5rem 0.4rem 0;
  background: #fff;
}

.process ul li img {
  height: 0.44rem;
}

.process ul li h4 {
  font-size: 0.22rem;
  color: #0b1d30;
  font-weight: bold;
  margin-top: 0.36rem;
}

.process ul li p {
  font-size: 0.16rem;
  color: #0b1d30;
  margin-top: 0.24rem;
  line-height: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/mtsapi.vue